import { motion } from "framer-motion";
import {
  Clapperboard, PenLine, Video, Scissors,
  Megaphone, Target, Filter, PenTool, ArrowUpRight,
} from "lucide-react";
import { SERVICES } from "../data/content";

const ICONS = [Clapperboard, PenLine, Video, Scissors, Megaphone, Target, Filter, PenTool];

export const Services = () => (
  <section id="services" data-testid="services-section" className="relative max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28">
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14">
      <div>
        <p className="font-mono2 text-xs sm:text-sm tracking-[0.25em] text-[#A3E635] uppercase mb-4">
          // Full-stack capabilities
        </p>
        <h2 className="font-heading text-3xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight leading-[1.0]">
          The Knowfinity<br />Universe
        </h2>
      </div>
      <p className="text-base sm:text-lg text-slate-400 max-w-sm leading-relaxed">
        8 core disciplines. One roof. Every content need your brand will ever have — engineered end to end.
      </p>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
      {SERVICES.map((s, i) => {
        const Icon = ICONS[i];
        return (
          <motion.div
            key={s.num}
            data-testid={`service-card-${s.num}`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, delay: (i % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className="trace-card group relative rounded-2xl border border-white/10 bg-[#121519]/80 p-7 overflow-hidden"
          >
            <div className="absolute -top-16 -right-16 h-36 w-36 rounded-full bg-[#A3E635]/10 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
            <div className="flex items-start justify-between mb-8">
              <span className="font-mono2 text-xs text-[#A3E635] tracking-[0.2em]">{s.num}</span>
              <Icon size={26} className="text-slate-500 group-hover:text-[#A3E635] transition-colors duration-500" />
            </div>
            <h3 className="font-heading text-lg sm:text-xl font-bold tracking-tight mb-3 leading-snug">
              {s.title}
            </h3>
            <p className="text-sm text-slate-400 leading-relaxed mb-6">{s.description}</p>
            <ArrowUpRight
              size={18}
              className="text-slate-600 group-hover:text-[#A3E635] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-500"
            />
          </motion.div>
        );
      })}
    </div>
  </section>
);
